import { ConversationItem } from '@app/models'

export const isSameConversation = (
  conversation: ConversationItem,
  id: string | number | null
): boolean => {
  if (id === null) return false

  const normalizedId =
    typeof id === 'string' ? id.toLowerCase() : Number(id) || id

  if (conversation.acsChatThreadId === id || conversation.id === normalizedId) {
    return true
  }

  return typeof id === 'string' &&
    conversation.reference?.toLowerCase() === id.toLowerCase()
}

export const getConversationById = (
  conversations: Record<number, ConversationItem> | null,
  id?: string | number
): ConversationItem | null => {
  if (!conversations || id === undefined) {
    return null
  }

  return Object.values(conversations).find((item) =>
    isSameConversation(item, id)
  ) ?? null
}
